:host {
  display: contents;
}

.body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-5);
  font-family: var(--font-sans);
  color: var(--color-gray-900);
  padding: var(--spacing-6) 0;
}

.heading {
  margin: 0;
  font-size: var(--text-lg);
  font-weight: 600;
  line-height: var(--leading-tight);
  outline: none;
}

/* ============================================================================
 * Success Banner
 * ========================================================================= */

.success-banner {
  box-sizing: border-box;
  width: 100%;
  padding: var(--spacing-4);
  border: 1px solid var(--color-green-600);
  border-radius: var(--radius-lg);
  background: var(--color-green-50);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.success-banner-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--color-green-600);
}

.success-banner-icon hcds-icon {
  --hcds-icon-size: var(--spacing-5);
  display: block;
}

.success-banner-text {
  flex: 1;
}

/* ============================================================================
 * Error Alert
 * ========================================================================= */

.error-alert {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  width: 100%;
  padding: var(--spacing-4);
  border: 1px solid var(--color-red-600);
  border-radius: var(--radius-lg);
  background: var(--color-red-50);
}

.error-alert-heading {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.error-alert-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--color-red-600);
}

.error-alert-icon hcds-icon {
  --hcds-icon-size: var(--spacing-5);
  display: block;
}

.error-alert-title {
  margin: 0;
  font-size: var(--text-base);
  line-height: var(--leading-normal);
}

.error-alert-message {
  margin: 0;
  font-size: var(--text-xs);
  line-height: var(--leading-normal);
}

/* ============================================================================
 * Screen-reader only utility
 * ========================================================================= */

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
